import React from 'react';
import PropTypes from 'prop-types';
import ImageTimeline from './Timeline';
import TimelineTooltip from './TimelineTooltip';

const ImageTimelineBlock = ({ imageDatasets, graphId, timelineValues }) => {
  return (
    <>
      {imageDatasets.map((imageDs) => {
        const cameraName = imageDs.PlacementName;
        const url = `/api/v1/camera-proxy/${imageDs.DatasetId.substring(imageDs.DatasetId.lastIndexOf('_') + 1)}/`;

        return (
          <div key={imageDs.DatasetId} className="my-4" data-graph-id={graphId} data-images-url={url}>
            <ImageTimeline
              url={url}
              graphId={graphId}
              cameraName={cameraName}
              Dataset={imageDs}
              timelineValues={timelineValues}
            />
          </div>
        );
      })}
      <TimelineTooltip tooltipId={graphId} />
    </>
  );
};

ImageTimelineBlock.propTypes = {
  imageDatasets: PropTypes.any.isRequired,
  graphId: PropTypes.any.isRequired,
  timelineValues: PropTypes.any.isRequired,
};

export default ImageTimelineBlock;
